/** The bridge mark, inline so it scales crisply and can take the currentColor field. */
export function Logo({ size = 30 }: { size?: number }) {
  return (
    <span
      className="inline-flex items-center justify-center rounded-[9px] bg-white"
      style={{ width: size, height: size }}
    >
      <svg
        width={size * 0.66}
        height={size * 0.66}
        viewBox="0 0 512 512"
        aria-hidden="true"
      >
        <g transform="translate(256,256) scale(1.28) translate(-256,-263)">
          <rect x="150" y="346" width="36" height="24" rx="12" fill="#54528D" />
          <rect x="326" y="346" width="36" height="24" rx="12" fill="#54528D" />
          <path
            d="M 185 190 Q 256 215 327 190 L 327 260 Q 256 285 185 260 Z"
            fill="#B0ABED"
          />
          <rect x="150" y="156" width="36" height="180" rx="18" fill="#A29CE4" />
          <rect x="326" y="156" width="36" height="180" rx="18" fill="#A29CE4" />
          <rect x="96" y="324" width="320" height="26" rx="13" fill="#A29CE4" />
        </g>
      </svg>
    </span>
  );
}

export function Wordmark({ size = 30, text = 19 }: { size?: number; text?: number }) {
  return (
    <div className="flex items-center gap-2.5">
      <Logo size={size} />
      <span
        className="font-display font-bold tracking-[-0.01em] text-forest-deep"
        style={{ fontSize: text }}
      >
        ClientBridge
      </span>
    </div>
  );
}
